const consoleLogger = (label = "", obj = "") => {
  if (process.env.NODE_ENV === "development" && typeof console.log !== "undefined") {
    console.log(label, obj);
  }
}

export default consoleLogger;
